import React from 'react'
import { Alert, Button, Image, Checkbox, Radio, FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap'
import * as firebase from 'firebase'
import '../App.css'
import FirebaseStateComponent from '../common/FirebaseStateComponent.js'
import Spinner from '../common/Spinner.js'

export default class ProfilePage extends FirebaseStateComponent {
  constructor (props) {
    super(props)

    this.tasksRef = null

    // Start with empty user object
    this.state = {
      user: null,
      newValues: {},
      alert: null,
      submitEnabled: false
    }

    // Add user binding
    this.handleProps(props, false)
  }

  refreshSubmitButton () {
    var enabled = false

    // Check if there is a user
    if (this.state.user !== null) {
      // Check new values in state
      if (Object.keys(this.state.newValues).length > 0) {
        enabled = true
      }
    }

    this.setState({submitEnabled: enabled})
  }

  refreshAlertMessage () {
    var message = null

    // Check if there is a user and if it is missing properties
    var user = this.state.user
    if (user && (!user.hasOwnProperty('single') || !user.dateOfBirth || !user.gender || !user.interests || Object.keys(user.interests).length === 0)) {
      message = 'Please finish your profile'
    }

    this.setState({alert: message})
  }

  userPropertyForKey (key, defaultValue = null) {
    if (this.state.newValues.hasOwnProperty(key)) {
      return this.state.newValues[key]
    } else if (this.state.user.hasOwnProperty(key)) {
      return this.state.user[key]
    } else {
      return defaultValue
    }
  }

  getAlert () {
    if (this.state.alert !== null) {
      return (
        <Alert bsStyle="warning">
          <strong>{this.state.alert}</strong>
        </Alert>
      )
    }

    return null
  }

  componentWillReceiveProps (nextProps) {
    // Process new props
    this.handleProps(nextProps)
  }

  handleProps (props, checkPrevious = true) {
    // Check if the new props contain the 'uid' value
    if (props.hasOwnProperty('uid') && props.uid !== null) {
      // Check if the value has changed
      if (!checkPrevious || !this.props.hasOwnProperty('uid') || this.props.uid !== props.uid) {
        this.addBinding('user', 'users/' + props.uid)
      }
    } else {
      // No new 'uid' value, remove user binding
      this.removeBinding('user')
    }
  }

  didUpdateStateValueForKey (stateKey) {
    // Refresh alert message
    if (stateKey === 'user') {
      this.refreshAlertMessage()
    }
  }

  getRenderedForm () {
    const user = this.state.user

    if (user === null) {
      return <Spinner />
    } else {
      const alert = this.getAlert()

      const displayName = this.userPropertyForKey('displayName', '')
      const dateOfBirth = this.userPropertyForKey('dateOfBirth', '')
      const single = this.userPropertyForKey('single', null)
      const gender = this.userPropertyForKey('gender', null)
      const interests = this.userPropertyForKey('interests', {})

      return (
        <div>
          {alert}
          <h2>My Profile</h2>
          <div>
            <Image circle src={user.photoURL} style={{height: '100px', width: '100px', marginTop: '15px', marginBottom: '20px'}} alt={user.displayName} />
          </div>
          <form>
            <FieldGroup id='displayName' type='text' label='Display name:' value={displayName} onChange={this.displayNameChanged} />
            <FieldGroup id='dateOfBirth' type='date' label='Date of birth:' value={dateOfBirth} onChange={this.dateOfBirthChanged} />
            <ControlLabel>Single:</ControlLabel>
            <FormGroup controlId='single'>
              <Radio id='yesSingleRadio' name='single' inline={true} checked={single === true} onChange={this.singleChanged}>Yes</Radio>
              <Radio id='noSingleRadio' name='single' inline={true} checked={single === false} onChange={this.singleChanged}>No</Radio>
            </FormGroup>
            <ControlLabel>Gender:</ControlLabel>
            <FormGroup controlId='gender'>
              <Radio id='male' name='gender' inline={true} checked={gender === 'male'} onChange={this.genderChanged}>Male</Radio>
              <Radio id='female' name='gender' inline={true} checked={gender === 'female'} onChange={this.genderChanged}>Female</Radio>
              <Radio id='other' name='gender' inline={true} checked={gender === 'other'} onChange={this.genderChanged}>Other</Radio>
            </FormGroup>
            <ControlLabel>Interested in:</ControlLabel>
            <FormGroup>
              <Checkbox id='male' inline={true} checked={interests.male === true} onChange={this.interestChanged}>Male</Checkbox>
              <Checkbox id='female' inline={true} checked={interests.female === true} onChange={this.interestChanged}>Female</Checkbox>
              <Checkbox id='other' inline={true} checked={interests.other === true} onChange={this.interestChanged}>Other</Checkbox>
            </FormGroup>
            <Button type='submit' disabled={!this.state.submitEnabled} onClick={this.submitButtonClicked}>Save</Button>
          </form>
        </div>
      )
    }
  }

  render () {
    const form = this.getRenderedForm()

    return (
      <div className='ProfilePage'>
        {form}
      </div>
    )
  }

  displayNameChanged = (event) => {
    this.saveNewValue('displayName', event.target.value)
  }

  dateOfBirthChanged = (event) => {
    this.saveNewValue('dateOfBirth', event.target.value)
  }

  singleChanged = (event) => {
    var single = (event.target.id === 'yesSingleRadio')

    this.saveNewValue('single', single)
  }

  genderChanged = (event) => {
    var gender = event.target.id

    this.saveNewValue('gender', gender)
  }

  interestChanged = (event) => {
    var gender = event.target.id
    var interested = event.target.checked

    // Update interests
    var interests = this.userPropertyForKey('interests', {})
    if (interested) {
      interests[gender] = true
    } else {
      delete interests[gender]
    }

    this.saveNewValue('interests', (Object.keys(interests).length > 0 ? interests : false))
  }

  saveNewValue = (key, value) => {
    // Update the value for the given key in the state
    var obj = this.state.newValues
    obj[key] = value
    this.setState({'newValues': obj}, () => {
      // Enable/disable submit button after state has been updated
      this.refreshSubmitButton()
    })
  }

  submitButtonClicked = (event) => {
    event.preventDefault()

    // Create editProfile task
    this.createEditProfileTask(this.state.newValues)

    // TODO: Listen for task success/failure
    // TODO: Show success/failure message

    // Clear new values and refresh submit button
    this.setState({newValues: {}}, () => {
      this.refreshSubmitButton()
    })
  }

  createEditProfileTask = (properties) => {
    console.log('Creating edit_profile task with properties: ' + JSON.stringify(properties))

    // Initialize firebase tasks reference on-demand
    if (this.tasksRef === null) {
      this.tasksRef = firebase.database().ref().child('queue/tasks')
    }

    // Push a new edit_profile task on the queue
    this.tasksRef.push({
      task: 'edit_profile',
      uid: this.state.user.uid,
      profile: properties
    })
  }
}

function FieldGroup ({id, label, help, ...props}) {
  return (
    <FormGroup controlId={id}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...props} />
      {help && <HelpBlock>{help}</HelpBlock>}
    </FormGroup>
  )
}



// WEBPACK FOOTER //
// ./src/pages/Profile.js